import { render, staticRenderFns } from "./Admin_list.vue?vue&type=template&id=536ebf84&scoped=true&"
import script from "./Admin_list.vue?vue&type=script&lang=js&"
export * from "./Admin_list.vue?vue&type=script&lang=js&"
import style0 from "./Admin_list.vue?vue&type=style&index=0&id=536ebf84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536ebf84",
  null
  
)

export default component.exports